/*
 Safari private mode detection based on https://github.com/Joe12387/detectIncognito/blob/0c3a287ff51bbd5068c15c16fcae78a0ae41a5c7/src/detectIncognito.ts#L101-L163
 */

export const isSafari = () => {
  const { vendor } = navigator;
  return (
    vendor !== undefined &&
    vendor.startsWith('Apple') &&
    eval.toString().length === 37 // eslint-disable-line no-eval
  );
};

const isOldSafariPrivateWindow = () => {
  const openDB = (window as any).openDatabase;
  const storage = window.localStorage;
  try {
    openDB(null, null, null, null);
  } catch {
    return true;
  }
  try {
    storage.setItem('test', '1');
    storage.removeItem('test');
  } catch {
    return true;
  }

  return false;
};

const isNewSafariPrivateWindow = () => {
  const temporaryName = String(Math.random());

  return new Promise((resolve) => {
    try {
      const database = window.indexedDB.open(temporaryName, 1);

      database.onupgradeneeded = function (index) {
        const result = (index.target as any)?.result;

        try {
          result
            .createObjectStore('test', {
              autoIncrement: true,
            })
            .put(new Blob());

          resolve(false);
        } catch (error) {
          let message = error;

          if (error instanceof Error) {
            message = error.message;
          }

          if (typeof message !== 'string') {
            return resolve(false);
          }

          const matchesExpectedError = message.includes(
            'BlobURLs are not yet supported',
          );

          return resolve(matchesExpectedError);
        } finally {
          result.close();
          window.indexedDB.deleteDatabase(temporaryName);
        }
      };
    } catch {
      resolve(false);
    }
  });
};

export const isSafariPrivateWindow = () => {
  if (!isSafari()) {
    return false;
  }

  return navigator.maxTouchPoints === undefined
    ? isOldSafariPrivateWindow()
    : isNewSafariPrivateWindow();
};
